export default __webpack_public_path__ + "static/media/edit.adda4d0a.svg";